import one from '../assets/svg/projects/one.png'
import two from '../assets/svg/projects/two.png'
import three from '../assets/svg/projects/three.png'
import four from '../assets/svg/projects/four.png'
// import five from '../assets/svg/projects/five.svg'
// import six from '../assets/svg/projects/six.svg'
// import seven from '../assets/svg/projects/seven.svg'
// import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Keeyan Manufacturing',
        projectDesc: 'User and admin panel. Users can log in, purchase, review the products, update their personal profiles and make payments. Admin can add, edit and manage products. Ship products after successful payments.',
        tags: ['Tailwind', 'React', 'Firebase', 'MongoDB'],
        code: 'https://github.com/ASMRSAEED/keeyan-manufacturing-client',
        demo: 'https://keeyan-manufacturing.web.app/',
        image: one
    },
    {
        id: 2,
        projectName: 'Grocery Manager',
        projectDesc: 'Users can log in, purchase and make payments. Admin can add, delete, update and manage stock. Fully Mobile Responsive.',
        tags: ['Bootstrap', 'React', 'Firebase', 'MongoDB'],
        code: 'https://github.com/ASMRSAEED/grocery-manager-client',
        demo: 'https://grocery-manager-a2e7a.web.app/',
        image: two
    },
    {
        id: 3,
        projectName: 'Mr. Doctor',
        projectDesc: 'It’s a single-page application (SPA). This website is made for selling any kind of professional services. After logging in, any customer book/purchase any available services.',
        tags: ['Bootstrap', 'React', 'Firebase'],
        code: 'https://github.com/ASMRSAEED/mr-doctor',
        demo: 'https://mr-doctor-4e732.web.app/',
        image: three
    },
    {
        id: 4,
        projectName: 'Doctors Portal',
        projectDesc: '  This website is made for booking doctors appointments. After logging in, any customer book/checkout any available services.',
        tags: ['Tailwind', 'React', 'Firebase', 'MongoDB'],
        code: 'https://github.com/ASMRSAEED/doctors-portal-client',
        demo: 'https://doctors-portal-14506.web.app/',
        image: four
    }/* ,
    {
        id: 5,
        projectName: 'E-Commerce App',
        projectDesc: 'A Simple E-commerce application',
        tags: ['React Native', 'Firebase'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: five
    },
    {
        id: 6,
        projectName: 'Uber Lite',
        projectDesc: 'Uber clone',
        tags: ['Flutter'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: six
    },
    {
        id: 7,
        projectName: 'Stock Market App',
        projectDesc: 'A simple stock market API app',
        tags: ['React', 'Redux', 'Bootstrap'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: seven
    },
    {
        id: 8,
        projectName: 'Car Pooling System',
        projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
        tags: ['Flutter', 'React'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: eight
    }, */
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/